/**
 * Parses a search value prefixing with 'contains:' to an array of strings.
 * E.g. 'contains:val1;val2' -> ['val1', 'val2']
 */
export const parseMultipleSearchValue = (value: string | undefined): string[] => {
  if (!value) return [];
  if (value.startsWith('contains:')) {
    return value.substring('contains:'.length).split(';').filter(Boolean);
  }
  return value.split(';').filter(Boolean);
};

/**
 * Formats an array of search values to a singular 'contains:' prefixed string if > 1 value.
 * E.g. ['val1'] -> 'val1'
 * E.g. ['val1', 'val2'] -> 'contains:val1;val2'
 */
export const formatMultipleSearchValue = (values: string[]): string => {
  const filtered = values.filter(Boolean);
  if (filtered.length > 1) {
    return `contains:${filtered.join(';')}`;
  }
  return filtered.join(';');
};
